module.exports = __webpack_public_path__ + "static/media/movie.b06ebe8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Calculator/icons/movie.png
// module id = 558
// module chunks = 0